<template>
  <div id="trs-main" class="crypt-register">
    <div class="device-support section">
      <div style="margin-bottom: 5%">
        <img style="height: 33px" :src="cryptoLogo">
      </div>

      <div style="padding-top: 15px;" v-html="$t('label.cryptoRegistration.closeAccountNote', {company_tel: postDocTemplate?.postDocTelephone})"></div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import IConstants from "@/common/constants/IConstants";
import cryptoRedirectMixin from '@/common/mixins/cryptoRedirect';
import {MENU_CRYPTO, SET_ACTIVE_TAB_ID} from '@/store/modules/header/type';

const {mapActions: mapHeaderActions} = createNamespacedHelpers('header');

export default {
  mixins:[cryptoRedirectMixin],
  data() {
    return {
      cryptoLogo: IConstants.LINK_ASSETS.CRYPTO_LOGO,
    }
  },
  created() {
    this[SET_ACTIVE_TAB_ID](MENU_CRYPTO);
    this.redirectCryptoRegistration();
  },
  methods: {
    ...mapHeaderActions([
      SET_ACTIVE_TAB_ID
    ]),
  },
}
</script>

<style scoped>
.device-support.section {
  margin-top: 0;
}
</style>
